<template>
  <div class="container-fluid">
    <div class="row dataTable-filters mt-5 mb-5" :class="filterOpenClass">
      <div class="col-md-4 col-lg-4 col-xl-4">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{
                selectedSender ? selectedSender.name : $t('shopfloor.teamlead.senderOverview.selectSender')
              }}</span>
          </button>
          <div class="dropdown-menu">
            <input type="text" class="form-control mb-3" :placeholder="$t('ui.search')" v-model="senderSearch">
            <div class="option-wrapper">
              <div class="custom-control custom-radio"
                   :key='sender.id' :value="sender.name" v-for="sender in getAvailableSendersFiltered">
                <input v-model="selectedSender"
                       :value="sender"
                       type="radio"
                       @change="senderChanged()"
                       :id="sender.name+'-id'"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="sender.name+'-id'">
                  <span>{{ sender.name }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-4 col-lg-4 col-xl-4" >

        <div class="btn btn-dark" v-if=selectedSender @click="unloadAllProducts()">Opdrachtgever fictief lossen</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <datatables
            v-if="selectedSender && channelOpened"
            :tableClass="tableClass"
            :rows="getOrdersUnsorted"
            :columns="getColumns"
            tableID="senderOverview"
            :tableInitOptions="tableInitOptions"
            :customFilters="customFilters"
            routerLinkClass="dt-router-link"
            deleteClass="delete"
        />
      </div>
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import dataTables from '../../mixins/datatables';


export default {
  name: 'teamlead-sender-overview',
  components: {},
  mixins: [dataTables],
  data() {
    return {
      selectedSender: null,
      senderSearch: '',
      filterOpen: false,
      channelOpened: false,
      filterOpenClass: 'm-hide-lg',
      searchProduct: '',
      searchLocation: '',
      searchCustomer: '',
      customFilters: [
        {
          filter: 'arrayContains',
          keyToFilter: 'id',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'locations',
          options: {
            keyToFilter: 'id',
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'customer',
          options: {
            keyToFilter: 'id',
            values: []
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters('incomingOrders', ['getOrders', 'getOrdersUnsorted', 'getGroupedBySender', 'getAvailableSenders']),
    ...mapGetters('incomingCargo', ['getIncomingCargos','getCargo']),
    ...mapGetters('locations', ['getLocation', 'getLocations']),
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('users', ['getMeBasic', 'getMyVirtualLocation']),
    ...mapGetters('customers', ['getCustomers']),
    getAvailableSendersFiltered() {
      return this.getCustomers.filter((search) => {
        return search.name.toLowerCase().indexOf(this.senderSearch.toLowerCase()) >= 0;
      }).sort(
          function (a, b) {
            if (a.name.trim().toLowerCase() < b.name.trim().toLowerCase()) return -1;
            if (a.name.trim().toLowerCase() > b.name.trim().toLowerCase()) return 1;
            return 0;
          }
      );
    },
    getColumns() {
      var self = this;
      return [
        {
          data: null,
          name: '',
          visible: true,
          searchable: false,
          orderable: true,
          responsivePriority: 1,
          render: function (data) {
            return data.fullyUnloaded ? `` : `<i class="fad fa-info-square"></i>`;
          }
        },
        {
          data: null,
          name: 'Vracht',
          visible: true,
          searchable: false,
          orderable: true,
          responsivePriority: 1,
          render: function (data) {
            return self.getCargoReference(data.cargoId)
          }
        },
        {
          data: 'title',
          name: 'Postcode',
          visible: true,
          searchable: true,
          orderable: false,
          responsivePriority: 1
        },
        {
          data: 'packingListNumber',
          name: this.$t('shopfloor.teamlead.senderOverview.table.packingListNumber'),
          visible: true,
          searchable: true,
          orderable: false,
          responsivePriority: 1
        },
        {
          data: 'receiverName',
          name: this.$t('shopfloor.teamlead.senderOverview.table.receiver'),
          visible: true,
          searchable: true,
          orderable: false,
          responsivePriority: 1
        },
        // {
        //   data: 'orderDate',
        //   name: this.$t('shopfloor.teamlead.senderOverview.table.orderDate'),
        //   visible: true,
        //   searchable: false,
        //   responsivePriority: 1,
        //   render: function (data) {
        //     return moment(data.toDate()).format('DD-MM-YY');
        //   }
        // },
        {
          data: 'deliveryDate',
          name: 'Datum',//this.$t('shopfloor.teamlead.senderOverview.table.deliveryDate'),
          visible: true,
          searchable: false,
          responsivePriority: 1,
          render: function (data) {
            return moment(data.toDate()).format('DD-MM-YY');
          }
        },
        {
          data: null,
          name: this.$t('table.options'),
          visible: true,
          searchable: false,
          orderable: false,
          render: function (data) {
            return `<a class="dt-router-link" data-to="/unloading/view/cargo/${data.cargoId}/order/${data.id}"><i class="fas fa-eye"></i></a>`;
          },
          responsivePriority: 1
        }
      ];
    }
  },
  methods: {
    ...mapMutations('incomingOrders', [
      'setCurrentProductPicking'
    ]),
    ...mapActions('incomingOrders',
        ['setCurrentOrderPicking']
    ),
    getCargoReference(cargoId){
      return this.getCargo(cargoId).reference
    },
    async unloadAllProducts() {
      let self = this
      let dayToUse = {
        day_before_yesterday_1: moment().startOf('day').subtract(3, 'days'),
        day_before_yesterday: moment().startOf('day').subtract(2, 'days'),
        yesterday: moment().startOf('day').subtract(1, 'days'),
        today: moment().startOf('day')
      }
      this.$swal({
        html: '<p>Weet je zeker dat alles fictief gelost moet worden van <br>  <strong>' + this.selectedSender.name + '</strong> voor </p>',
        showCancelButton: true,
        showConfirmButton: true,
        input: 'select',
        inputOptions: {
          'day_before_yesterday_1':  dayToUse.day_before_yesterday_1.format('DD-MM-YYYY'),
          'day_before_yesterday': dayToUse.day_before_yesterday.format('DD-MM-YYYY'),
          'yesterday': dayToUse.yesterday.format('DD-MM-YYYY'),
          'today': dayToUse.today.format('DD-MM-YYYY')
        },
      }).then(async res => {
        if (res.value) {
              await this.$FB.collection('batch-unload').add({
                companyId: this.getMeBasic.companyId,
                endTime: new Date(),
                locationId: self.getMyVirtualLocation,
                barcodeUnreadable:true,
                startTime: new Date(),
                userId: this.getMeBasic.userId,
                userName: this.getMeBasic.userName,
                dateFrom:dayToUse[res.value].toDate(),
                dateTo:dayToUse[res.value].endOf('day').toDate(),
                type:{
                  value:this.selectedSender.name,
                  key:'customer',
                }
              })
          return this.$swal({
            customClass: {
              header: 'align-items-center'
            },
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            type: 'success',
            title: this.$root.$t('shopfloor.teamlead.loading.saveSuccess')
          });

        }
      })

    },
    senderChanged() {
      this.channelOpened = false;
      if (this.selectedSender) {
        this.$store.dispatch('incomingOrders/closeDBChannel', {clearModule: true}).then(() => {
          if (this.selectedSender === 'all-customers') {
            this.$store.dispatch('initDataForPage', ['incomingOrders']).then(() => {
              this.channelOpened = true;
            });
          } else {
            this.$store.dispatch('initDataForPage', [{
              module: 'incomingOrders',
              where: ['customer', '==', this.selectedSender.name]
            }]).then(() => {
              this.channelOpened = true;
            });
          }
        });
      }
    }
  },
  watch: {},
  async beforeRouteLeave(from, to, next) {
    await this.$store.dispatch('resetStoreModules', [
      'incomingOrders',
    ]).catch(console.error);
    next();
  },
  created() {
    this.tableInitOptions.language = {
      searchPlaceholder: this.$t('table.search'),
      sProcessing: this.$t('table.processing'),
      sLengthMenu: '_MENU_',
      sZeroRecords: this.$t('table.noResults'),
      sInfo: this.$t('table.filteredFrom', ['_START_', '_END_', '_TOTAL_']),
      sInfoEmpty: this.$t('table.noResultsDisplay'),
      sInfoFiltered: ' ' + this.$t('table.filteredFrom', ['_MAX_']),
      sInfoPostFix: '',
      sSearch: '',
      sEmptyTable: this.$t('table.noResultsDisplay'),
      sInfoThousands: '.',
      sLoadingRecords: this.$t('table.processing'),
      oPaginate: {
        sFirst: this.$t('table.first'),
        sLast: this.$t('table.last'),
        sNext: this.$t('table.next'),
        sPrevious: this.$t('table.previous')
      },
      oAria: {
        sSortAscending: ': activeer om kolom oplopend te sorteren',
        sSortDescending: ': activeer om kolom aflopend te sorteren'
      }
    };
    this.$store.dispatch('initDataForPage', [])
  }
};
</script>


<style lang="scss">

.dataTable tbody td:last-child {
  text-align: left !important;
}

.fa-info-square, .fa-eye {
  font-size: 20px;
}
</style>



